import * as sdk from '../sdk';
import { browserHistory } from 'react-router';
import { hideTOS, showTOS } from '../actions/profileActions';
import { clearPrivacyPolicy } from '../actions/privacyPolicyActions';

export const storeTos = (payload) => {
  return {
    type: 'STORE_TOS',
    payload
  }
}

export const clearTos = () => {
  return {
    type: 'CLEAR_TOS'
  }
}


export const getTos = () => {
  return (dispatch, getState) => {
    return sdk.getTos(getState().auth.jwToken)
      .then(response => {
        dispatch(storeTos(response.data.data));
      });
  }
}

export const acceptTos = tos_version => {
  return (dispatch, getState) => {
    dispatch(hideTOS());
    return sdk.acceptTos(getState().auth.jwToken, tos_version)
      .then(response => {
        window.location.reload();
      })
      .catch(err => {
        if(err) {
          console.log(err);
          dispatch(showTOS());
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/actions/tosActions.js